<template>
	<div>
		<!--TABELA Z KONKURSAMI-->
		<v-card-title class="mb-3">
			<h2 style="padding-left: 10px">Konkursy</h2>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="mb-1 ml-3"
				v-if="roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee()">Nowy
				konkurs
			</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline">Nowy konkurs</span>
				</v-card-title>
				<v-card-text>
					<v-form
						ref="form"
						v-model="newItem.valid"
						lazy-validation>
						<v-text-field
							browser-autocomplete="off"
							name="name"
							label="Nazwa konkursu"
							aria-label="contest name"
							for="contest-list-view-name-contest"
							id="contest-list-view-name-contest"
							v-model="newItem.name"
							:rules="validationRules"
							type="text">
						</v-text-field>
						<v-text-field
							browser-autocomplete="off"
							name="shortName"
							label="Skrócona nazwa konkursu"
							aria-label="short contest name"
							for="contest-list-view-short-name-contest"
							id="contest-list-view-short-name-contest"
							v-model="newItem.shortName"
							:rules="validationRules"
							type="text">
						</v-text-field>
						<v-flex xs12 sm6 md4 v-if="!roles.isDepartmentEmployee() && !roles.isLocalAdministrator()">
							<v-autocomplete name="Departament" v-model="newItem.departmentId" :items="departments"
								label="Departament *"
								aria-label="department"
								for="contest-list-view-department"
								id="contest-list-view-department"
								item-text="name"
								item-value="id"
								data-vv-name="department"
								data-vv-as="Departament"
								:rules="validationRules"></v-autocomplete>
						</v-flex>
					</v-form>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="save">
						Zapisz
					</v-btn>
					<v-btn color="blue" @click="cancel">Anuluj</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<PublicContestDataTable ref="contestTable" v-model="dataTable"/>
	</div>
</template>

<script>

	import {Api} from "@/api";
	import PublicContestDataTable from "./components/PublicContestDataTable";

	export default {
		name: "ContestListView",
		components: {
			PublicContestDataTable,
		},


		watch: {
			dialog(val) {
				if (!val) {
					this.vErrors.clear();
				} else {
					Api.get(this, "/department/list", response => {
						this.departments = response;
					});
				}
			},
		},

		mounted () {
			this.removeEmptyTableLoading();
		},

		methods: {
			save() {
				if (!this.$refs.form.validate()) {
					return;
				}
				Api.post(this, "/public-contest", this.newItem, () => {
						// wywołanie przeładowania konkursów (metoda komponentu)
						this.$refs.contestTable.getItemList();
						this.dialog = false;
						this.clearDialog();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});

			},

			cancel() {
				this.dialog = false;
				this.clearDialog();
			},

			clearDialog() {
				this.newItem.name = "";
				this.newItem.shortName = "";
				this.newItem.departmentId = null;
			},

			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

		},

		data() {
			return {

				dataTable: {
					searchFields: {},
					tableHeaders: [
						{text: "", value: "termExpirationStatus", sortable: false},
						{text: "Nazwa konkursu", value: "contestName", sortable: true},
						{text: "Koniec naboru ofert", value: "endDate", sortable: true},
						{text: "Departament", value: "departmentName", sortable: true},
						{text: "Akcje", value: "action", sortable: false},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: "",
					},
					search: "",
				},
				departments: [],
				dialog: false,

				newItem: {
					name: "",
					shortName: "",
					departmentId: null,
					valid: true,
				},

				validationRules: [
					v => !!v || "To pole jest wymagane",
				],
			};
		},
	};
</script>

<style scoped>

</style>
